<template>
  <div class="mx-10 mt-10 text-left">
    <div class="flex gap-5">
      <div>
        <div>formCode</div>
        <sInput :value.sync="newFormParams.formCode"/>
      </div>
      <div>
        <div>tenderId</div>
        <sInputNumber
          :empty-value="null"
          :precision="0"
          :use-thousand-separator="false"
          :value.sync="newFormParams.tenderId"/>
      </div>
      <div>
        <div>contactId</div>
        <sInputNumber
          :empty-value="null"
          :precision="0"
          :use-thousand-separator="false"
          :value.sync="newFormParams.contactId"/>
      </div>
      <div>
        <div>disabled</div>
        <sCheckbox
          v-model="disabled"/>
      </div>
    </div>
    <sButton @click="getForm">
      getForm
    </sButton>
    <sDivider
      class="my-5"
      color="currentColor"/>
    <div class="grid mb-10 gap-5">
      <sRadioGroup
        v-model="formVersion"
        row>
        <sRadio
          key="old"
          :label="'old'">
          Версия 0
        </sRadio>
        <sRadio
          key="new"
          :label="'new'">
          Версия 1
        </sRadio>
      </sRadioGroup>
    </div>
    <div
      v-if="showFormio"
      style="display: grid;">
      <component
        :is="formVersion === 'new' ? 'SpilkaFormioMF' : 'SpilkaFormioMFOld'"
        ref="formioForm"
        :disabled="disabled"
        :form-params="formVersion === 'new' ? newFormParams : {formCode: newFormParams.formCode}"
        :hide-submit="true"
        :key-draft="keyDraft"
        :show-alert="false"
        @initialized="loadForm = false"
        @submit-error="errorFormio"/>
    </div>
    <sDivider
      class="my-5"
      color="currentColor">
      Кнопки не относятся к FormiO
    </sDivider>
    <sButton
      @click="formSubmission">
      formSubmission (тестова кнопка)
    </sButton>
    <sButton
      data-qa="save-as-draft"
      icon="diskette"
      :loading="loadForm"
      type="text"
      @click="saveDraft">
      {{ $t('Application.SaveAsDraft') }}
    </sButton>
    <sButton
      data-qa="load-draft"
      icon="diskette"
      :loading="loadForm"
      type="text"
      @click="loadDraft">
      Завантажити чернетку
    </sButton>
  </div>
</template>
<script>
import SpilkaFormioMF from 'components/common/SpilkaFormioMF.vue'

import SpilkaFormioMFOld from 'components/common/SpilkaFormioMFOld.vue'

import { storageMixin } from 'mixins'
import formio from 'mixins/formio'

export default {
  name: 'testFormio',
  mixins: [formio, storageMixin],
  data() {
    return {
      keyDraft: 'test-formio',//'test-formio',
      loadForm: true,
      showFormio: false,
      disabled: false,
      formVersion: 'old',
      newFormParams: {
        formCode: 'DTEK_START', //'TEST_EVENT', TENDERORGDIAGRAM, DTEK_OPENONESTAGEBIDDINGFINANCEANDECONOMYDEPARTMENT_2
        tenderId: 6303087,
        contactId: 851147
      },
    }
  },
  methods: {
    getForm() {
      this.$_savePropToLocalStorage('testFormio', this.newFormParams, true)
      if (this.newFormParams?.formCode) {
        this.$refs.formioForm?.loadData()
        this.$refs.formioFormOld?.loadData()
      }
    },
    errorFormio() {
      this.$notice.error({
        title: 'Error',
        duration: 10
      })
    },
    validateResult(result) {
      this.$notice.info({
        title: 'validateResult',
        message: result,
        duration: 10
      })
    },
    async submitValid() {
      this.$spinner.show()
      const eventModel = {
        formCode: this.newFormParams?.formCode,
        tenderId: this.newFormParams?.tenderId,
        diagramId: null,
        submission: JSON.stringify(this.$refs.formioForm.formData?.submission?.data ?? {}),
        components: JSON.stringify(this.$refs.formioForm.formData?.components ?? [])
      }
      this.$_formSubmission(eventModel)
        .then((result) => {
          if (result.success) {
            this.$notice.info({
              title: 'result',
              dangerouslyUseHTMLString: true,
              message: 'Все ок',
              showClose: true,
              progress: true,
            })
          } else {
            this.$notice.error({
              title: 'result',
              dangerouslyUseHTMLString: true,
              message: JSON.stringify(result),
              showClose: true,
              progress: true,
            })
          }
        })
        .finally(() => {
          this.$spinner.close()
        })
    },
    loadDraft() {
      this.$refs.formioForm.applyDraft()
    },
    saveDraft() {
      this.$refs.formioForm.saveDraft()
      this.$notice.info({
        title: this.$t('Application.DraftSaved'),
        duration: 10
      })
    },
    formSubmission() {
      if (this.formVersion === 'old') {
        this.$refs.formioForm.submit()
        return
      }

      this.$refs.formioForm.validate()
        .then((result) => {
          this.$sinfo('formSubmission result', result)
          if (result.result) {
            this.submitValid()
          }
        })
    }
  },
  computed: {
  },
  components: {
    SpilkaFormioMF,
    SpilkaFormioMFOld,
  },
  mounted() {
    try {
      const settings = this.$_getPropFromLocalStorage('testFormio', null, true)
      this.newFormParams = settings || this.newFormParams
    } catch (_) {
      // ignore
    }
    this.showFormio = true
  }
}
</script>
